'use client';

import { Box } from '@skin-seoul/design-system';

/**
 * Loading skeleton component for FilterSidebar
 * Matches the dimensions and layout of the actual FilterSidebar
 */
const FilterSidebarSkeleton = () => <Box width={{
  base: '240px',
  tablet: '260px',
  desktop: '280px'
}} minWidth={{
  base: '240px',
  tablet: '260px',
  desktop: '280px'
}} maxWidth="280px" paddingRight={6} paddingY={4} height="fit-content" flexShrink={0} data-sentry-element="Box" data-sentry-component="FilterSidebarSkeleton" data-sentry-source-file="FilterSidebarSkeleton.tsx">
    <Box height="200px" backgroundColor="neutral.100" borderRadius="4px" data-sentry-element="Box" data-sentry-source-file="FilterSidebarSkeleton.tsx" />
  </Box>;
export default FilterSidebarSkeleton;